var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaElbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_7287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_7287)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3138,
    cy: 31.8856,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9507 11.7485C16.9626 11.7499 18.1232 11.9179 19.664 13.2797C22.2811 15.5923 23.9383 19.4789 24.8675 22.3325C24.9173 22.4857 25.0302 22.6094 25.1774 22.674C25.249 22.7049 25.3247 22.7204 25.4012 22.7204C25.4825 22.7204 25.5632 22.7028 25.6382 22.6677C25.6494 22.6621 26.8128 22.1224 28.862 21.4844C30.7512 20.8955 33.8025 20.0993 37.607 19.651C37.9149 19.6145 38.1351 19.3355 38.0986 19.027C38.0621 18.7186 37.7837 18.4979 37.4758 18.5345C33.5732 18.9947 30.4413 19.8134 28.5015 20.4191C27.2245 20.8182 26.2897 21.1759 25.7392 21.4014C22.2847 11.3368 17.2971 10.6566 17.0825 10.632C16.7747 10.5975 16.4942 10.8182 16.4591 11.1267C16.424 11.4351 16.6428 11.7134 16.9507 11.7485ZM41.7922 28.5886C41.6828 28.2977 41.3595 28.1515 41.0692 28.2604L24.8506 34.3802C23.8632 34.6578 22.7131 34.5524 21.5224 34.0752C20.4157 33.6318 19.3575 32.8989 18.5391 32.0093L6.79891 19.4451C6.58712 19.2182 6.23227 19.2069 6.00576 19.4191C5.77924 19.6314 5.76802 19.9869 5.97981 20.2139L17.7179 32.7752C19.1099 34.2889 21.4284 35.657 23.7202 35.657C24.2118 35.657 24.702 35.5938 25.1816 35.456L25.2034 35.4497L41.4647 29.3138C41.7544 29.2042 41.9009 28.8802 41.7922 28.5893V28.5886ZM20.1178 28.7642C22.7581 27.4256 24.8241 27.798 26.0927 28.3461L26.0913 28.3468C27.4736 28.9441 28.2232 29.8696 28.2548 29.9089C28.4484 30.1521 28.4091 30.5055 28.1671 30.6995C28.0641 30.7824 27.9399 30.8224 27.8172 30.8224C27.6538 30.8224 27.4911 30.7508 27.3803 30.613C27.2779 30.4865 24.8739 27.6132 20.6241 29.7677C20.3478 29.9075 20.0098 29.7965 19.8703 29.5196C19.7307 29.2428 19.8415 28.9048 20.1178 28.7642Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3164,
    y: 39.4062,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(-35 24.3164 39.4062)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(-0.984808 -0.173648 -0.173648 0.984808 22.7471 38.4331)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(-0.573577 -0.819152 -0.819152 0.573576 19.5889 38.5728)",
    fill: "#5096E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaElbow);
export default __webpack_public_path__ + "static/media/ja_elbow.6d003e3cf16a200f5486ce12b1453954.svg";
export { ForwardRef as ReactComponent };